export const DRAFT_ORDERS = 'new-admin-draft-orders';
export const ABANDONED_CARTS = 'new-admin-abandoned-carts';
export const ORDERS_SHOW_CARD_STATISTICS_STATUS =
  'new-admin-orders-show-card-statistics-status';

export const SHIPPING_MULTICD = 'new-admin-multicd';
export const UNIFIED_SHIPPING_DOCUMENTS =
  'new-admin-unified-shipping-documents';
export const SHIPPING_LIMITATIONS = 'new-admin-shipping-limitations';

export const APP_DEV_EXPERIMENTAL = 'new-admin-app-dev-experimental';
export const PRODUCT_DESCRIPTION_EDITOR_ENABLED =
  'new-admin-product-description-editor-enabled';

export const CATALOG_INVENTORY = 'new-admin-multicd-inventory';
export const CATALOG_LAZY_VARIANTS = 'new-admin-catalog-lazy-variants';
export const CATALOG_ENABLE_INF_STOCK_MODAL =
  'new-admin-catalog-enable-inf-stock-modal';
export const CATALOG_LIGHT_VIDEO_URL_VALIDATION =
  'new-admin-catalog-light-video-url-validation';
export const CATALOG_FULL_EVENTS = 'new-admin-catalog-full-events';
export const CATALOG_UPLOAD_VIDEOS = 'new-admin-catalog-upload-videos';
export const CATALOG_ALLOW_EXTRA_CATEGORIES =
  'new-admin-catalog-allow-extra-categories';
export const CATALOG_MF_OPEN_AS_TEXTAREA =
  'new-admin-catalog-mf-open-as-textarea';
export const CATALOG_STOCK_TRANSFER = 'new-admin-catalog-stock-transfer';
export const CATALOG_ST_BET_B = 'new-admin-catalog-st-bet-b';
export const CATALOG_MS_SEARCH = 'new-admin-catalog-ms-search';
export const CATALOG_CSV_METAFIELDS = 'new-admin-catalog-csv-metafields';
export const CATALOG_ATTRIBUTES_UNCASE = 'new-admin-catalog-attributes-uncase';

export const NEW_ADMIN_METAFIELDS_CUSTOMER_FILTER =
  'new-admin-metafields-customer-filter';
export const NEW_ADMIN_EVENT_CATEGORIES = 'new-admin-catalog-event-categories';
export const NEW_ADMIN_EVENT_EDIT_VARIANT_STOCK =
  'new-admin-catalog-event-edit-variant-stock';

export const NUVEMPAGO_ENABLED = 'nuvempago';

export const NUVEMENVIO_ADMIN_BLOCK = 'nuvem-envio-admin-blocking';
export const NUVEMENVIO_JADLOG_COMMUNICATION =
  'new-admin-nuvem-envio-jadlog-communication';
export const NUVEMENVIO_CORREIOS_COMMUNICATION =
  'new-admin-nuvem-envio-correios-communication';
export const NUVEMENVIO_CYBER_MONDAY_BANNER =
  'new-admin-en-banner-colecta-2025-09';
export const NUVEMENVIO_BLACK_FRIDAY_BANNER =
  'new-admin-ne-banner-collect-2025-09';
export const NUVEMENVIO_LOGGI_BANNER = 'new-admin-ne-banner-pp-loggi-2025-09';
export const NUVEMENVIO_CYBER_MONDAY_RATE_BANNER =
  'new-admin-en-banner-pp-2025-09';

export const MIGRATION_ORDERS = 'new-admin-web-orders';
export const MIGRATION_ORDER = 'new-admin-web-order';
export const MIGRATION_ABANDONED_CARTS = 'new-admin-web-abandoned_list';
export const MIGRATION_ORDERS_EXPORT = 'new-admin-web-orders_download';
export const MIGRATION_SOCIAL_NETWORKS = 'new-admin-web-social_networks';
export const MIGRATION_ORDERS_EXPORT_FORCE = 'new-admin-web-orders-export';
export const MIGRATION_ABANDONED_CARTS_FORCE = 'new-admin-web-abandoned-carts';
export const MIGRATION_ORDER_DETAIL_FORCE = 'new-admin-web-order-detail';
export const MIGRATION_ORDERS_LIST_FORCE = 'new-admin-web-order-list';

export const MIGRATION_ENABLE_ALL_MIGRATED_PAGES =
  'new-admin-enable-all-migrated-pages';
export const TRANSACTION_FEES_NEW_CHECKOUT_TAG =
  'billing-new-checkout-transaction-fees';

//TAGS TO FORCE REDIRECT TO OLD ADMIN
export const MIGRATION_OLD_COUPONS = 'new-admin-old-discount_list';
export const MIGRATION_OLD_DRAFT_ORDERS = 'new-admin-old-draft_orders';
export const MIGRATION_OLD_CUSTOMERS = 'new-admin-old-customers';
export const MIGRATION_OLD_MESSAGES = 'new-admin-old-contacts';
export const MIGRATION_OLD_CATEGORIES = 'new-admin-old-categories';
export const MIGRATION_OLD_PRODUCTS_IMPORT = 'new-admin-old-product_import';
export const MIGRATION_OLD_PRODUCT_ORDER = 'new-admin-old-product_order';
export const MIGRATION_OLD_PASSWORD_PROTECTED =
  'new-admin-old-password_protected';
export const MIGRATION_OLD_MARKETING_APPS = 'new-admin-old-marketing_apps';
export const MIGRATION_OLD_SALES_CHANNELS_APPS =
  'new-admin-old-sales_channel_apps';
export const MIGRATION_OLD_CONTENT_PAGES = 'new-admin-old-pages';
export const MIGRATION_OLD_I18N = 'new-admin-old-i18n';
export const MIGRATION_OLD_MENUS = 'new-admin-old-navigation';
export const MIGRATION_OLD_FREE_SHIPPING = 'new-admin-old-get_free_shipping';
export const MIGRATION_OLD_PROMOTIONS = 'new-admin-old-promotions_list';
export const MIGRATION_OLD_CONTENT_SETTINGS_CHECKOUT =
  'new-admin-old-preferences_checkout';
export const MIGRATION_OLD_USERS = 'new-admin-old-users';
export const MIGRATION_OLD_PREFERENCES_ADVANCED =
  'new-admin-old-preferences_advanced';
export const MIGRATION_OLD_NOTIFICATIONS = 'new-admin-old-notifications';
export const MIGRATION_OLD_MARKETPLACES_APPS = 'new-admin-old-meli_apps';
export const MIGRATION_OLD_DASHBOARD = 'new-admin-old-home';
export const MIGRATION_OLD_SEO_REDIRECTS = 'new-admin-old-seo_redirects';
export const MIGRATION_OLD_WHATSAPP = 'new-admin-old-whatsapp';
export const MIGRATION_OLD_THEMES = 'new-admin-old-themes';
export const MIGRATION_OLD_INFO_MESSAGE = 'new-admin-old-emergency';
export const MIGRATION_OLD_DOMAINS = 'new-admin-old-domains';
export const MIGRATION_OLD_APPS = 'new-admin-old-apps';
export const MIGRATION_OLD_FACEBOOK = 'new-admin-old-facebook';
export const MIGRATION_OLD_INSTAGRAM = 'new-admin-old-instagram';
export const MIGRATION_OLD_PAYMENTS = 'new-admin-old-payments';

//TAGS FROM DOMAINS
export const SOCIAL_GOOGLE_ADMIN = 'new-google-admin';
export const SOCIAL_TIKTOK_ADMIN = 'new-tiktok-admin';
export const SOCIAL_GA4_DATA_API_OAUTH_DISABLED =
  'social-ga4-data-api-oauth-disabled';
export const SOCIAL_OLD_SALES_CHANNELS_MENU = 'social-old-sales-channels-menu';
export const SOCIAL_NEW_GOOGLE_UX = 'social-new-google-ux';
export const SOCIAL_NEW_META_UX = 'social-new-meta-ux';
export const SOCIAL_NEW_TIKTOK_UX = 'social-new-tiktok-ux';
export const SOCIAL_GOOGLE_HUB_REVAMP_25Q3_TAG =
  'social-google-hub-revamp-25q3';
export const TRAFFIC_META_HUB_REVAMP_25Q4_TAG = 'traffic-meta-hub-revamp-25q4';
export const TRAFFIC_TIKTOK_HUB_REVAMP_25Q4_TAG =
  'traffic-tiktok-hub-revamp-25q4';
export const TRAFFIC_GOOGLE_ADS_STATIC_RECOMMENDATIONS_2025_TAG =
  'traffic-google-ads-static-recommendations-2025';
export const TRAFFIC_PINTEREST_ADMIN_DISABLE_TAG =
  'traffic-pinterest-admin-disable';
export const SOCIAL_FEATURES = [
  SOCIAL_GOOGLE_ADMIN,
  SOCIAL_TIKTOK_ADMIN,
  SOCIAL_OLD_SALES_CHANNELS_MENU,
  SOCIAL_NEW_GOOGLE_UX,
  SOCIAL_NEW_META_UX,
  SOCIAL_NEW_TIKTOK_UX,
  SOCIAL_GOOGLE_HUB_REVAMP_25Q3_TAG,
  TRAFFIC_GOOGLE_ADS_STATIC_RECOMMENDATIONS_2025_TAG,
  TRAFFIC_PINTEREST_ADMIN_DISABLE_TAG,
  TRAFFIC_META_HUB_REVAMP_25Q4_TAG,
  TRAFFIC_TIKTOK_HUB_REVAMP_25Q4_TAG,
];
export const ENABLED_HAS_NO_CATEGORIES = 'api-enable-has-no-categories';
export const SUNSET_MELI_SYNC = 'sunset-meli-sync';
export const ORDERS_ALLOW_PRODUCT_NAME_FILTER = 'allow-product-name-filter';
export const USER_PASSWORD_CHANGE_REQUIRED_ENABLED =
  'account-takeover-user-passwords-audit-enabled';
export const TOTAL_PAID_ORDER_DETAIL = 'new-admin-total-paid-order-detail';
export const AUTO_SETTING_NUVEM_PAGO = 'nuvempago-new-cohort-activated';
export const MUST_REFRESH_MERCADOPAGO_TOKEN = 'must-refresh-mercadopago-token';
export const PAGSEGURO_REVOKED_PERMISSIONS = 'pagseguro-revoked-permissions';
export const MERCADOPAGO_NOT_VERIFIED = 'mercadopago-not-verified';
export const MANUAL_TX_FEE_PAYMENT_TAG =
  'billing-manual-tx-fee-until-next-month';
export const QUITO_FACEBOOK_V2 = 'quito-fbe-v2';
export const SMART_PAYMENT = 'smart-payment';
export const SMART_PAYMENT_ADMIN = 'smart-payment-admin';
export const ONLINE_CURRENT_THEME_SURVEY = 'online-current-theme-survey';
export const ZENDESK_LIVE_CHAT_WIDGET_TAG = 'zendesk-live-chat-widget';
export const MARKETING_AUTOMATION_ENABLED = 'new-admin-marketing-automation';
export const PHISHING_SUSPECT_TAG = 'phishing-suspect';
export const UPDATE_APP_NOTIFICATIONS_ALERT_TAG =
  'update-app-notifications-alert';
export const EXCLUDE_NEW_PERMISSIONS_TAG = 'new-admin-exclude-new-permissions';
export const NON_FREEMIUM_PLANS_PAGE_TAG = 'billing-non-freemium-plans-page';
export const AI_PRODUCT_IMAGE_SMART_ERASE_ENABLED =
  'ai-product-image-smart-erase-enabled';
export const AI_PRODUCT_CATEGORY_SUGGESTIONS_ENABLED =
  'ai-product-category-suggestions-enabled';
export const AI_PRODUCTS_FROM_IMAGES = 'ai-products-from-images';
export const AI_SINGLE_PRODUCT_FROM_IMAGES = 'ai-single-product-from-images';
export const AI_CATEGORIES_DESCRIPTION_ENABLED =
  'ai-categories-description-enabled';
export const AI_PRODUCT_FEEDBACK_ENABLED = 'ai-product-feedback-enabled';
export const CATALOG_EXTENDED_CATEGORY_DESCRIPTION =
  'new-admin-catalog-extended-category-description';
export const ORDERS_EDIT_DISCOUNTS = 'new-admin-edit-order-discounts';
export const ORDERS_SURVEY_ENABLED = 'new-admin-orders-survey-enabled';
export const ORDERS_BULK_PICKUP_ENABLED =
  'new-admin-orders-bulk-pickup-enabled';
export const ORDERS_AUTO_CANCEL_PROMOTION =
  'new-admin-orders-auto-cancel-promotion';
export const ORDERS_LIST_PAGE_FULL_WIDTH =
  'new-admin-orders-list-page-full-width';

export const PROMOTIONS_PAYMENT_OPTIONS_LIMIT_TAG = 'prm-payment-options-limit';
export const PROMOTIONS_GRANULAR_COMBINATION_TAG =
  'prm-promotions-advanced-combinations';
export const DOMAINS_ERROR_ALERT_TAG = 'new-admin-domains-error-alert';

export const SHOW_PROMOTE_TASKS_MOBILE_TAG =
  'new-admin-mobile-show-promote-tasks';
export const BILLING_UPSELL_DISCOUNT = 'new-admin-upsell-discount-202507-b';
export const BILLING_NEW_FLOW_FREQUENCY = 'billing-new-flow-frequency';

export const BILLING_NEW_ALERTS_FLOW = 'billing-new-alerts-flow';

export const ONBOARDING_RECOMMEND_PLAN = 'new-admin-recommend-plan-202507-b';
export const ONBOARDING_RECOMMEND_PLAN_FORCE =
  'new-admin-recommend-plan-202507-force';

export const NUVEM_CHAT_MENU_ENABLED = 'nuvem-chat-menu-enabled';
export const NUVEM_CHAT_BILLING_DISABLED = 'nuvem-chat-billing-disabled';
export const NUVEM_CHAT_ONBOARDING_FINISHED = 'nuvem-chat-onboarding-finished';
export const NUVEM_CHAT_WAITLIST = 'nuvem-chat-waitlist';
export const NUVEM_CHAT = 'onboarding_nuvem_chat';

export const EXTERNAL_TRACKING_CODE = 'new-admin-external-tracking-code';

export const PROJECT_SHIVA_TAG = 'project-shiva';
export const PROJECT_BOLD_TAG = 'project-bold';

export const DOMAIN_REQUIRED_UPDATE = 'domain-ns-update-required';
export const DOMAIN_REQUIRED_UPDATE_SOFTBLOCK =
  'domain-ns-update-required-softblock';
export const DOMAIN_REQUIRED_UPDATE_HARDBLOCK =
  'domain-ns-update-required-hardblock';
export const DOMAIN_NS_UPDATED_CORRECT = 'domain-ns-updated-correct';
export const NUVEM_DOMAINS_TAG = 'new-admin-nuvem-domains';

export const PAYMENTS_REFUND_EXTERNAL_PARTNERS_TAG =
  'new-admin-refund-external-partners';

export const ENVIO_NUBE_ADMIN_AR = 'envio-nube-admin-ar';
export const ENVIO_NUBE_ADMIN_MX = 'envio-nube-admin-mx';

// B2B feature tags
export const B2B_WHOLESALE = 'b2b-wholesale';

export const INVOICE_ENABLED = 'new-admin-invoices';
export const EXTERNAL_INVOICES_ENABLED = 'new-admin-external-invoices';
export const NEW_ADMIN_INVOICES = 'new-admin-invoices';
export const NEW_ADMIN_INVOICES_AR = 'new-admin-invoices-ar';

export const CATALOG_UNSTABLE_API_V2 = 'new-admin-catalog-unstable-api-v2';

export const IS_PAGO_NUBE_ONBOARDING_ON = 'fs-pagonube-onboarding-on';

export const DOMAIN_DISCONNECTED = 'new-admin-domain-disconnected';

export const FS_NUVEMPAGO_NUDGES_VARIANT = 'fs-nuvempago-nudges-variant';

export const FS_NUVEMPAGO_STORE_CREATION_VARIANT =
  'fs-nuvempago-store-creation-variant';

export const FS_NUVEMPAGO_TASK_ONBOARDING_ENABLE =
  'fs-nuvempago-taskonboarding-enable';

export const FS_NUVEMPAGO_ONBOARDING_HOME_CARD_VARIANT =
  'fs-nuvempago-onboarding-home-card-variant';

export const CUSTOM_PROMOTION_LABEL_ENABLED =
  'new-admin-online-custom-promotion-label';

export const OPTIONAL_CANCEL_REFUNDED_ORDER_TAG =
  'new-admin-optional-cancel-refunded-order';

export const LIVEVIEW_ACCESS = 'liveview-access';
export const NUBEINSIGHTS_VISITS = 'nubeinsights-visits';
export const NUBEINSIGHTS_PRODUCTS = 'nubeinsights-products';
export const NUBEINSIGHTS_SALES = 'nubeinsights-sales';
export const NUBEINSIGHTS_GENERAL = 'nubeinsights-general';
export const NUBEINSIGHTS_SEARCH_INSIGHTS = 'nubeinsights-search-insights';

export const STATISTICS_SALES_CHANNELS_REVENUE =
  'new-admin-statistics-sales-channels-revenue';

export const CHECKOUT_HISTORY_TRANSACTIONS = 'checkout-history-transactions';

export const NEW_ADMIN_WHATSAPP_NOTIFICATIONS =
  'new-admin-whatsapp-notifications';

export const NEW_ADMIN_SUBSCRIPTIONS_ENABLED =
  'new-admin-subscriptions-enabled';

export const NEW_ADMIN_SUBSCRIPTIONS_SECTION =
  'new-admin-subscriptions-section';

export const PAYM_ABANDONED_CARTS = 'new-admin-paym-abandoned-carts';

export const CATALOG_EXTRA_SORT_LIMIT = 'new-admin-catalog-extra-sort-limit';
export const CATALOG_PRODUCT_HASHED_SLUG = 'catalog-product-hashed-slug';

export const CLOUDFLARE_SOFTBLOCK = 'new-admin-cloudflare-softblock';

export const CATALOG_CHAT_AGENT_ENABLED = 'new-admin-catalog-show-lumi-202510';
export const DEVICE_INFO_MENU_OPTION_ENABLED = 'new-admin-device-info-menu';

export const NEW_ADMIN_ONBOARDING_COLLAPSE_MENU_202511 =
  'new-admin-onboarding-collapse-menu-202511';

export const PICPAY_PROJECT = 'picpay3';

export const PAYMENT_STATUS_EXPIRED_ENABLED =
  'new-admin-payment-status-expired';
